import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/bookingChange';

import { create } from './utils';

export default function* listenCreate() {
  yield takeEvery(actions.create.toString(), create);
}
